const o = [
  {
    text: "Default",
    value: ""
  },
  {
    text: "Serif",
    value: "serif"
  },
  {
    text: "Sans Serif",
    value: "sans-serif"
  },
  {
    text: "Monospace",
    value: "monospace"
  }
], t = o.filter((e) => e.value).map(
  (e) => e.value
), i = ["transparent"], r = {
  left: "left",
  center: "center",
  right: "right",
  justify: "justify"
}, c = r.left, _ = {
  left: "intercom-interblocks-align-left",
  center: "intercom-interblocks-align-center",
  right: "intercom-interblocks-align-right",
  justify: "intercom-interblocks-align-justify"
}, s = {
  "intercom-interblocks-align-left": "left",
  "intercom-interblocks-align-center": "center",
  "intercom-interblocks-align-right": "right",
  "intercom-interblocks-align-justify": "justify"
}, n = "entity_mention", l = "no-margin", m = {
  AUDIO_FILE: "audioFile",
  PARAGRAPH: "paragraph",
  IMAGE: "image",
  IMAGE_TEXT: "imageText",
  INLINE_IMAGE: "inlineImage",
  ORDERED_LIST: "orderedList",
  UNORDERED_LIST: "unorderedList",
  HEADING: "heading",
  SUBHEADING: "subheading",
  SUBHEADING3: "subheading3",
  SUBHEADING4: "subheading4",
  SMALL: "small",
  CODE: "code",
  HTML: "html",
  VIDEO: "video",
  VIDEO_FILE: "videoFile",
  BUTTON: "button",
  HORIZONTAL_RULE: "horizontalRule",
  MESSENGER_CARD: "messengerCard",
  ATTACHMENT_LIST: "attachmentList",
  SOCIAL: "social",
  SPACER: "spacer",
  TABLE: "table",
  TABLE_CELL: "tableCell",
  ORDERED_NESTED_LIST: "orderedNestedList",
  UNORDERED_NESTED_LIST: "unorderedNestedList",
  IF_ELSE_STATEMENT: "ifElseStatement",
  CREATE_TICKET_CARD: "createTicketCard",
  FACEBOOK_LIKE_BUTTON: "facebookLikeButton",
  TWITTER_FOLLOW_BUTTON: "twitterFollowButton",
  CALLOUT: "callout",
  COLLAPSIBLE_SECTION: "collapsibleSection",
  COLLAPSIBLE_SECTION_SUMMARY: "collapsibleSectionSummary",
  COLLAPSIBLE_SECTION_CONTENT: "collapsibleSectionContent",
  UNSUPPORTED_ELEMENT: "unsupportedElement"
}, a = {
  blockContainer: "embercom-prosemirror-composer-block-container",
  audio: "embercom-prosemirror-composer-audio",
  video: "embercom-prosemirror-composer-video",
  button: "embercom-prosemirror-composer-button",
  image: "embercom-prosemirror-composer-image",
  imageText: "embercom-prosemirror-composer-imagetext",
  table: "embercom-prosemirror-composer-table intercom-interblocks-table",
  code: "embercom-prosemirror-composer-code",
  placeholder: "embercom-prosemirror-composer-placeholder-block",
  social: "embercom-prosemirror-composer-social",
  spacer: "embercom-prosemirror-composer-spacer",
  divider: "embercom-prosemirror-composer-divider",
  callout: "embercom-prosemirror-composer-callout",
  collapsibleSection: "embercom-prosemirror-composer-collapsible-section",
  collapsibleSectionContent: "embercom-prosemirror-composer-collapsible-section-content"
}, E = "___________________________________________________________";
export {
  r as ALIGNMENTS,
  _ as ALIGN_CLASSES,
  s as ALIGN_CLASSES_INVERSE,
  a as BLOCK_CLASSES,
  m as BLOCK_TYPES,
  c as DEFAULT_ALIGNMENT,
  i as DISALLOWED_COLOR_VALUES,
  t as FONT_FAMILIES,
  o as FONT_FAMILIES_DATA,
  E as HORIZONTAL_RULE_FALLBACK,
  n as MENTION_CLASS,
  l as NO_MARGIN_CLASS
};
